import React from 'react';
import PropTypes from 'prop-types';
import {
  Row, Col, Form, Input, FormInstance,
} from 'antd';
import './NewPassword.scss';

const NewPassword = (
  props: {
    vertical: number,
    form: FormInstance,
    newPasswordLabelCol: any,
    confirmPasswordLabelCol: any,
  },
): JSX.Element => {
  const {
    vertical,
    form: formObject,
    newPasswordLabelCol,
    confirmPasswordLabelCol,
  } = props;

  const handleConfirmBlur = (): void => {
    // ?
  };

  const setOrientationStyle = (verticalStyle: number) => {
    let newStyle;

    switch (verticalStyle) {
      case 1:
        newStyle = { span: 12, offset: 6 };
        break;

      case 2:
        newStyle = { span: 24 };
        break;

      case 3:
        newStyle = { span: 12 };
        break;

      default:
        break;
    }

    return newStyle;
  };

  const compareToFirstPassword = (_rule: any, value: string): Promise<void | Error> => {
    if (value && value !== formObject.getFieldValue('newPassword')) {
      return Promise.reject(new Error('Nova senha e confirmar nova senha devem ser iguais'));
    }

    if (value && value === formObject.getFieldValue('oldPassword')) {
      return Promise.reject(new Error('Informe uma senha diferente da atual'));
    }

    return Promise.resolve();
  };

  const validateToNextPassword = (_rule: any, value: string): Promise<void | Error> => {
    if (value && value.length < 6) {
      return Promise.reject(new Error('A senha deve conter pelo menos 6 caracteres.'));
    }

    if (value && value === formObject.getFieldValue('oldPassword')) {
      return Promise.reject(new Error('Informe uma senha diferente da atual'));
    }

    return Promise.resolve();
  };

  return (
    <div className="NewPassword">
      <Row gutter={[24, 24]}>
        <Col
          xs={{ span: 24 }}
          lg={setOrientationStyle(vertical)}
        >
          <Form.Item
            label="Nova senha"
            name="newPassword"
            labelCol={newPasswordLabelCol}
            rules={[
              {
                required: true, message: 'Por favor, insira uma nova senha.',
              },
              {
                validator: validateToNextPassword,
              },
            ]}
          >
            <Input
              name="password"
              type="password"
              placeholder="Nova senha"
            />
          </Form.Item>
        </Col>
        <Col
          xs={{ span: 24 }}
          lg={setOrientationStyle(vertical)}
        >
          <Form.Item
            label="Confirmar nova senha"
            name="confirmPassword"
            labelCol={confirmPasswordLabelCol}
            rules={[
              {
                required: true,
                message: 'Por favor, insira a confirmação da senha nova.',
              },
              {
                validator: compareToFirstPassword,
              },
            ]}
          >
            <Input
              name="confirmPassword"
              type="password"
              placeholder="Confirmar senha nova"
              onBlur={handleConfirmBlur}
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

NewPassword.propTypes = {
  vertical: PropTypes.number,

  form: PropTypes.shape({
    getFieldValue: PropTypes.func.isRequired,
  }).isRequired,

  newPasswordLabelCol: PropTypes.shape({}),
  confirmPasswordLabelCol: PropTypes.shape({}),
};

NewPassword.defaultProps = {
  vertical: false,
  newPasswordLabelCol: { span: 24 },
  confirmPasswordLabelCol: { span: 24 },
};

export default NewPassword;
